import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AdminUsersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('navigation.users')} - Admin
      </Typography>
      <Typography variant="body1">
        User management and role assignment interface will be implemented here.
      </Typography>
    </Box>
  );
};

export default AdminUsersPage;